module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_5.5d391542.png";